<template>
    <div class="h-100">
        <article class="news-card h-100 d-flex flex-column">
            <a
                v-if="newsItem.img"
                :href="newsItem.url"
                class="cover"
            >
                <img
                    :src="newsItem.img"
                    :alt="newsItem.title"
                >
            </a>
            <div class="body flex-1 d-flex flex-column">
                <div class="flex-1">
                    <div
                        v-if="newsItem.category"
                        class="param"
                    >
                        <div class="type">
                            <a :href="categoryRoute+'/'+newsItem.categorySlug">{{ newsItem.category }}</a>
                        </div>
                    </div>
                    <div class="date-wrap">
                        <div class="date">
                            <span class="timestamp">{{ newsItem.date }}</span>
                            &nbsp; | &nbsp;
                            <span
                                v-if="newsItem.length"
                                class="timestamp"
                            >{{ newsItem.length }}</span>
                        </div>
                    </div>
                    <div class="title">
                        <h3><a :href="newsItem.url">{{ newsItem.title }}</a></h3>
                    </div>
                    <div
                        class="desc limit-text-4"
                        v-html="newsItem.lead"
                    />
                </div>
                <div class="controls">
                    <div class="cont-types">
                        <svg
                            v-if="newsItem.type === 'sound'"
                            class="icon icon-audio"
                            :alt="__('The article contains audio')"
                        ><use xlink:href="#icon-audio" /></svg>

                        <svg
                            v-if="newsItem.type === 'video'"
                            class="icon icon-video"
                            :alt="__('The article contains video')"
                        ><use xlink:href="#icon-video" /></svg>
                    </div>
                    <a
                        :href="newsItem.url"
                        class="btn-more text-transform-none"
                    >
                        {{ __('Read more') }} <svg class="icon icon-shortarrow"><use xlink:href="#icon-shortarrow" /></svg>
                    </a>
                </div>
            </div>
        </article>
    </div>
</template>

<!-- eslint-disable vue/no-v-html -->
<script>
export default {
    name: 'NewsItem',

    props: {
        newsItem: {
            type: Object,
            required: true
        },
        categoryRoute: {
            type: String,
            required: true
        },
    }
}
</script>
